/**
 * Reaching a customer from their order (ADR-059): a WhatsApp chat, a call.
 *
 * Saudi stores talk to customers on WhatsApp more than by email, and the
 * number on an order is typed however the shopper typed it — `05…`, `+966 5…`,
 * Arabic-Indic digits. `wa.me` takes only the international number in Latin
 * digits, so it is normalised here once rather than at every link.
 */

const ARABIC_INDIC = /[٠-٩]/g;
const EASTERN_ARABIC_INDIC = /[۰-۹]/g;

/** The number in international form, digits only — `966501234567` — or null when it is not one. */
export function internationalDigits(phone: string | null | undefined, countryCode = '966'): string | null {
  if (!phone) return null;
  const latin = phone
    .replace(ARABIC_INDIC, (digit) => String(digit.charCodeAt(0) - 0x0660))
    .replace(EASTERN_ARABIC_INDIC, (digit) => String(digit.charCodeAt(0) - 0x06f0));
  let digits = latin.replace(/\D/g, '');
  if (latin.trim().startsWith('00')) digits = digits.slice(2);
  // A local Saudi mobile, 05XXXXXXXX: the trunk zero gives way to the country code.
  else if (digits.length === 10 && digits.startsWith('0')) digits = countryCode + digits.slice(1);
  // Nine digits starting 5: the zero was left off.
  else if (digits.length === 9 && digits.startsWith('5')) digits = countryCode + digits;
  return digits.length >= 8 && digits.length <= 15 ? digits : null;
}

export function whatsappLink(phone: string | null | undefined): string | null {
  const digits = internationalDigits(phone);
  return digits ? `https://wa.me/${digits}` : null;
}

export function telLink(phone: string | null | undefined): string | null {
  const digits = internationalDigits(phone);
  return digits ? `tel:+${digits}` : null;
}
